module.exports = __webpack_public_path__ + "img/Group3.a86ed299.png";